$(function () {
    const storedData = localStorage.getItem('userData');

    if (storedData) {
        const userData = JSON.parse(storedData).data;

        const fieldsConfig = [
            { name: 'firstName', value: userData?.customer_first_name },
            { name: 'lastName', value: userData?.customer_last_name },
            { name: 'email', value: userData?.customer_email },
            { name: 'serialNumber', value: userData?.serial },
        ];

        fieldsConfig.forEach(({ name, value }) => {
            const $field = $(`[name="bike_registration[${name}]"]`);
            if (value && $field.length) {
                $field.siblings('.label-up').addClass('goUp');
                $field.val(value).removeClass('empty-field');
            }
        });

        const $dateField = $('[name="bike_registration[purchasedAt]"]');
        if (userData?.date_of_purchase && $dateField.length) {
            $dateField.siblings('.label-up').addClass('goUp');
            let date = new Date(userData.date_of_purchase);
            let formatted = date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
            $dateField
                .val(formatted)
                .removeClass('empty-field');
        }

        const $modelField = $('[name="bike_registration[model]"]');
        if (userData?.bike_model_short || userData?.bike_model) {
            const rawModel = userData?.bike_model_short || userData?.bike_model;
            const optionValue = rawModel?.replace(/_/g, ' ');

            if (optionValue && $modelField.length) {
                const optionExists = $modelField.find(`option[value="${optionValue}"]`).length > 0;

                if (optionExists) {
                    $modelField.siblings('.label-up').addClass('goUp');
                    $modelField.val(optionValue).removeClass('empty-field');
                }
            }
        }

        const $countryField = $('[name="bike_registration[country]"]');
        if (userData?.country_of_residence && $countryField.length) {
            let optionExists = $countryField.find("option[value='" + userData.country_of_residence + "']").length > 0;
            if (optionExists) {
                $countryField.siblings('.label-up').addClass('goUp');
                $countryField
                    .val(userData.country_of_residence)
                    .removeClass('empty-field');
            }
        }
    }

    $('.bike-registration input, .bike-registration textarea').blur(function () {
        let element = $(this);
        setTimeout(function () {
            if (element.val() == "") {
                element.siblings('.label-up').removeClass('goUp');
                element.removeClass('light-red');
            } else {
                element.siblings('.label-up').addClass('goUp');
            }
        });
    });

    $('.bike-registration input, .bike-registration textarea, .bike-registration select').change(function () {
        if ($(this).val().trim().length === 0) {
            $(this).addClass('empty-field');
        } else {
            $(this).removeClass('empty-field');
            $(this).removeClass('light-red');
        }

        if ($(this).attr('name') === 'bike_registration[model]' && $('.help-text').length && theme.registrHelpText.setting.length) {
            const hasProduct = theme.registrHelpTextProductList.some(item => item.title === $(this).val());
            $('.help-text').attr('aria-hidden', !hasProduct);
        }
    });

    //============== datepicker ==================//
    $(".registration_monthpicker").datepicker({
        dateFormat: 'MM yy',
        maxDate: '0',
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        currentText: "This month",
        onClose: function() {
            $(this).siblings('.label-up').addClass('goUp');
            var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
            var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
            $(this).val($.datepicker.formatDate('MM yy', new Date(year, month, 1)));
            $(this).change();
        },
        beforeShow: function () {
            $("#ui-datepicker-div").addClass("hide-calendar");
        },
        yearRange: 'c-10: c+10'
    });

    $(".registration_birthday_monthpicker").datepicker({
        dateFormat: "dd.mm.yy",
        maxDate: '0',
        minDate: new Date(2000, 1 - 1, 1),
        changeMonth: true,
        changeYear: true,
        beforeShow: function () {
            $("#ui-datepicker-div").removeClass("hide-calendar");
        },
        onClose: function() {
            $(this).siblings('.label-up').addClass('goUp');
        },
        yearRange: 'c-100: c+100'
    });


    $('.bike-registration__open-form').on('click', function () {
        $(this).toggleClass('open');
        $(this).siblings('.hidden-block').toggleClass('open');
    });

	function isElementInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
		  rect.top >= 0 &&
		  rect.left >= 0 &&
		  rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		  rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

    $('.bike-registration-form button[type="submit"]').on('click', function (e) {
        e.preventDefault();

	    const form = this.closest('form');

	    if (!form.checkValidity()) {
		    const firstInvalidField = form.querySelector(':invalid');
		    if (firstInvalidField && !isElementInViewport(firstInvalidField)) {
			    firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'start' });
			    firstInvalidField.focus();
			    setTimeout(function () {
				    firstInvalidField.reportValidity();
			    }, 750);
		    }
		    return;
	    }

        let actionUrl = $(form).attr('action');
        let emptyFieldSize = $(form).find('.empty-field');

        $(form).find('.empty-field').each(function (ind, element) {
            $(element).addClass('light-red');
        });

        if (emptyFieldSize.length > 0) return false;

        let formData = new FormData(form);

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data : formData,
            processData: false,
            contentType: false,
            success: function (result) {
                $("html, body").animate({ scrollTop: 0 }, 600);
                form.reset();
                $('.label-up').removeClass('goUp');
                $("#bike_warranty_proof").val('');
                $('.bike_warranty_proof').html('');
                $(form).find('.success-msg').show();

                if (e.target.hasAttribute('data-redirect-url')) {
                    const redirectUrl = e.target.getAttribute('data-redirect-url');
                    window.location.href = redirectUrl;
                }
            },
            error: function (XMLHttpRequest, textStatus, result) {
                //console.log('error ', textStatus);
            },
            complete: function() {
                //console.log('complete');
            }
        });
    });
});


window.addEventListener('beforeunload', () => {
    localStorage.removeItem('userData');
});